"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toasterAction = void 0;

var _stylitas = require("@creditas/stylitas");

const toasterAction = (0, _stylitas.css)`
  max-width: 94px;
  padding-left: 8px;
  padding-right: 8px;

  * {
    text-align: center;
  }
`;
exports.toasterAction = toasterAction;